exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sizing--product[data-v-222d1ab4]{text-align:center}@media screen and (min-width:48em){.sizing--product[data-v-222d1ab4]{text-align:left}}@media screen and (min-width:48em){.sizing--product.list--unordered[data-v-222d1ab4]{padding-left:0}}.sizing--product .base-info--entry[data-v-222d1ab4]{cursor:pointer;display:inline-block;padding-right:22px}.sizing--product .base-info--entry[data-v-222d1ab4]:before{top:2px;color:#009fe3}.sizing--product .base-info--entry[data-v-222d1ab4]:last-child{padding-right:0}@media screen and (min-width:48em){.sizing--product .base-info--entry[data-v-222d1ab4]{padding-right:0;display:list-item}}.sizing--product .base-info--entry[data-v-222d1ab4]:not(.is--active),.sizing--product .base-info--entry[data-v-222d1ab4]:not(.is--active):before{color:#a3a3a3}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-222d1ab4","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/PriceList.vue
// module id = 388
// module chunks = 0